import { render } from "./AssignedProducts.vue?vue&type=template&id=731b1838&ts=true"
import script from "./AssignedProducts.vue?vue&type=script&lang=ts"
export * from "./AssignedProducts.vue?vue&type=script&lang=ts"

import "./AssignedProducts.vue?vue&type=style&index=0&id=731b1838&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__